import { z } from 'zod';

const environmentSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default('/api/v1'),
  VITE_API_TIMEOUT_MS: z.coerce.number().positive().default(15000),
  VITE_APP_ENV: z.enum(['development', 'test', 'production']).default('development'),
  VITE_ENABLE_AUDIT: z.string().default('true').transform((value) => value === 'true'),
  VITE_ENABLE_USERS: z.string().default('true').transform((value) => value === 'true'),
  VITE_ENABLE_ROLES: z.string().default('true').transform((value) => value === 'true'),
  VITE_MAINTENANCE_MODE: z.string().default('false').transform((value) => value === 'true'),
});

export type AppEnvironment = z.infer<typeof environmentSchema>;
export function parseEnvironment(source: Record<string, unknown>): AppEnvironment {
  return environmentSchema.parse(source);
}
